import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate } from "react-router-dom";

export default function CreatePermissionPage() {
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [permission, setPermission] = useState({
        name: "",
        displayName: "",
        description: "",
        category: "",
    });

    const [categories, setCategories] = useState([]); //  لتخزين الكاتيجوريز
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formError, setFormError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    //  دالة لتحديث القيم
    const handleChange = (field, value) => {
        setPermission((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    //  دالة لجلب الكاتيجوريز من السيرفر
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res = await backEnd_request.get("/admin/Permissions/categories");
                setCategories(res.data || []);
            } catch (err) {
                console.error("فشل في جلب الكاتيجوريز:", err);
            }
        };
        fetchCategories();
    }, [backEnd_request]);

    //  تحقق من القيم
    const validate = () => {
        if (!permission.name.trim()) return "الرجاء إدخال الاسم";
        if (!permission.displayName.trim()) return "الرجاء إدخال الاسم الظاهر";
        if (!permission.category.trim()) return "الرجاء اختيار الفئة";
        return "";
    };

    //  عند إرسال النموذج
    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormError("");
        setSuccessMessage("");

        const error = validate();
        if (error) {
            setFormError(error);
            return;
        }

        setIsSubmitting(true);
        try {
            const res = await backEnd_request.post("/admin/Permissions", permission);
            console.log("✅ تم إنشاء الصلاحية:", res.data);
            setSuccessMessage("تمت إضافة الصلاحية بنجاح!");
            navigate("/admin/permissions-management", {
                state: { successMessage: "تمت إضافة الصلاحية بنجاح!" },
            });
        } catch (err) {
            console.error(err.response?.data?.message || err);
            setFormError(err.response?.data?.message || "حدث خطأ أثناء الإرسال");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="bg-light min-vh-100 d-flex align-items-center">
            <div className="container">
                <div className="text-center mb-5">
                    <h1
                        className="text-light fw-bold"
                        style={{ fontSize: "2.3rem", letterSpacing: "1px" }}
                    >
                        إضافة صلاحية جديدة
                    </h1>
                    <p className="text-light" style={{ fontSize: "1.1rem" }}>
                        يرجى إدخال جميع المعلومات المطلوبة لإضافة صلاحية جديدة للنظام
                    </p>
                </div>

                <div className="d-flex justify-content-center">
                    <div
                        className="card border-0 shadow-lg"
                        style={{
                            width: "100%",
                            maxWidth: "700px",
                            borderRadius: "20px",
                        }}
                    >
                        <div
                            className="card-header text-center py-4"
                            style={{
                                backgroundColor: "#f8f9fa",
                                borderTopLeftRadius: "20px",
                                borderTopRightRadius: "20px",
                            }}
                        >
                            <h3 className="text-dark m-0 fw-bold">معلومات الصلاحية</h3>
                        </div>

                        <div className="card-body bg-white p-5 rounded-bottom">
                            <form onSubmit={handleSubmit}>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="الاسم (Name)"
                                            value={permission.name}
                                            onChange={(e) =>
                                                handleChange("name", e.target.value)
                                            }
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="الاسم الظاهر (Display Name)"
                                            value={permission.displayName}
                                            onChange={(e) =>
                                                handleChange("displayName", e.target.value)
                                            }
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>
                                    <div className="col-12">
                                        {/*  القائمة المنسدلة للفئات */}
                                        <select
                                            className="form-select p-3"
                                            value={permission.category}
                                            onChange={(e) =>
                                                handleChange("category", e.target.value)
                                            }
                                            style={{ borderRadius: "12px" }}
                                        >
                                            <option value="">اختر الفئة</option>
                                            {categories.map((cat, index) => (
                                                <option key={index} value={cat}>
                                                    {cat}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-12">
                                        <textarea
                                            className="form-control p-3"
                                            placeholder="الوصف (اختياري)"
                                            rows="3"
                                            value={permission.description}
                                            onChange={(e) =>
                                                handleChange("description", e.target.value)
                                            }
                                            style={{ borderRadius: "12px" }}
                                        ></textarea>
                                    </div>
                                </div>

                                <div className="mt-4">
                                    <button
                                        type="submit"
                                        className={`btn w-100 py-3 fw-bold ${isSubmitting
                                            ? "btn-secondary"
                                            : "btn-dark text-light"
                                            }`}
                                        style={{
                                            borderRadius: "12px",
                                            fontSize: "1.1rem",
                                        }}
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? "جارٍ الإرسال..." : "إضافة الصلاحية"}
                                    </button>
                                </div>

                                {formError && (
                                    <div className="text-danger text-center mt-3 fw-bold">
                                        {formError}
                                    </div>
                                )}
                                {successMessage && (
                                    <div className="text-success text-center mt-3 fw-bold">
                                        {successMessage}
                                    </div>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
